import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

const PlusIcon = (props: IconProps) => {
  return (
    <Icon
      aria-hidden="true"
      data-prefix="fas"
      data-icon="plus"
      viewBox="0 0 448 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M416 208H272V64a32 32 0 0 0-32-32h-32a32 32 0 0 0-32 32v144H32a32 32 0 0 0-32 32v32a32 32 0 0 0 32 32h144v144a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V304h144a32 32 0 0 0 32-32v-32a32 32 0 0 0-32-32z"
      />
    </Icon>
  );
};

export default PlusIcon;
